<template>
  <div class="bg-orange shadow-text py-3">
    <div class="container">
      <div class="row align-items-center justify-content-between">
        <div
          class="col-lg-12 d-flex flex-column align-items-center justify-content-center"
        >
          <h1 class="text-center thin">Mid-Year Deal</h1>

          <h1 class="text-center bigger constrain pb-3">
            Get a <span>Featured Listing</span> with less cost and less
            commitment.
          </h1>

          <div
            class="d-flex align-items-center justify-content-center countdown pb-3"
            v-if="future(endDate)"
          >
            <div class="me-4">
              <h2 class="text-center mb-0">{{ countdown.days }}</h2>
              <span class="subheader text-center">DAYS</span>
            </div>
            <div class="me-4">
              <h2 class="text-center mb-0">{{ countdown.hours }}</h2>
              <span class="subheader text-center">HOURS</span>
            </div>
            <div class="me-4">
              <h2 class="text-center mb-0">{{ countdown.minutes }}</h2>
              <span class="subheader text-center">MINUTES</span>
            </div>
            <div class="">
              <h2 class="text-center mb-0">{{ countdown.seconds }}</h2>
              <span class="subheader text-center">SECONDS</span>
            </div>
          </div>

          <p class="text-center text-muted">
            Offer expires
            {{ prettyDate(endDate) }}.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.vh100 {
  height: 100vh;
}

.countdown {
  h2 {
    line-height: 20px !important;
  }
  .subheader {
    font-size: 14px !important;
    line-height: 20px !important;
  }
}

h1 {
  font-weight: bolder;
}
</style>

<script>
import {
  parse,
  format,
  differenceInSeconds,
  isFuture,
  setHours,
} from "date-fns";

export default {
  name: "upgrade.tops.six-month-orange",
  props: {
    price: Number,
    site: Object,
  },
  data() {
    return {
      endDate: null,
      countdown: {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
      },
      timer: null,
    };
  },
  methods: {
    prettyDate(date) {
      if (date) {
        return format(date, "MMMM do, yyyy");
      }
    },
    future(date) {
      if (date) {
        return isFuture(date);
      } else {
        return false;
      }
    },
    updateCountdown() {
      const diffInSeconds = differenceInSeconds(
        this.endDate,
        new Date().getTime()
      );
      const ONE_DAY = 60 * 60 * 24;
      const ONE_HOUR = 60 * 60;
      const ONE_MINUTE = 60;
      if (diffInSeconds <= 1) {
        this.countdown = {
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0,
        };
      }
      const days = Math.floor(diffInSeconds / ONE_DAY);
      const hours = Math.floor((diffInSeconds - days * ONE_DAY) / ONE_HOUR);
      const minutes = Math.floor(
        (diffInSeconds - days * ONE_DAY - hours * ONE_HOUR) / ONE_MINUTE
      );
      const seconds =
        diffInSeconds -
        days * ONE_DAY -
        hours * ONE_HOUR -
        minutes * ONE_MINUTE;
      this.countdown = {
        days,
        hours,
        minutes,
        seconds,
      };
    },
  },
  mounted() {
    if (this.$route.query.end) {
      this.endDate = setHours(
        parse(this.$route.query.end, "MM-dd-yyyy", new Date()),
        17
      );
      if (!this.timer) {
        this.updateCountdown();
        setInterval(() => this.updateCountdown(), 1000);
      }
    }
  },
};
</script>
